import { createFileRoute, Outlet } from "@tanstack/react-router";

import { guardModuleRoute } from "@/lib/module-guard";

export const Route = createFileRoute("/stock")({
  beforeLoad: ({ location }) => guardModuleRoute(location.pathname),
  head: () => ({ meta: [{ title: "Stock · AVS Gold ERP" }] }),
  component: () => <Outlet />,
});
